import { render } from "./ShirtSize.vue?vue&type=template&id=77b164a1"
import script from "./ShirtSize.vue?vue&type=script&lang=js"
export * from "./ShirtSize.vue?vue&type=script&lang=js"
script.render = render

export default script